import { render, staticRenderFns } from "./shouzhen.vue?vue&type=template&id=3d322f79&scoped=true&"
import script from "./shouzhen.vue?vue&type=script&lang=ts&"
export * from "./shouzhen.vue?vue&type=script&lang=ts&"
import style0 from "./shouzhen.vue?vue&type=style&index=0&id=3d322f79&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d322f79",
  null
  
)

export default component.exports